import { render, staticRenderFns } from "./BookForSingle.vue?vue&type=template&id=c8780402"
import script from "./BookForSingle.vue?vue&type=script&lang=js"
export * from "./BookForSingle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports